import "./MenuItemList.scss";

import React from "react";

import { Dropdown } from "react-bootstrap";
import MenuList from "../../articles/lists/overview-item-list/MenuList";
import { MenuItem } from "../../../datatypes/MenuItem";
import LinkContainer from "../LinkContainer";

/* This wrapper is a workaround for the issue that the MenuItem component contains a link <a>,
 * which would lead to two links contained inside each other.
 * Instead of using it, we use this wrapper that gets a onSelect prop from the Dropdown.Menu
 * component.
 * If we don't use the MenuItem component (or this wrapper),
 * the Dropdown won't close properly on repeated selects (see BT-6173 for example).
 */
function Wrapper(props: { onSelect?: () => {}; item: MenuItem }) {
    return (
        <div className="ex-menu-dropdown-bg" onClick={props.onSelect}>
            <MenuList topLevelMenuItem={props.item} />
        </div>
    );
}

/*
 * This is an ugly hack to make the dropdown close and still keep valid html. Usually we are only allowed
 * to have <li> in an <ul> tag and only <a> are allowed in <li>. Our styling is based on this. We dont follow
 * this principle, however. To make the dropdown still close, we therefore use the injected onSelect (from the dropdown menu) to
 * select an item.
 *
 * This is hacky and should be replaced by manual transitioning with the router.
 */
function ListItem(props: { onSelect?: () => {}; item: any; className?: string }) {
    return (
        <li onClick={props.onSelect}>
            {props.item.relativeURL ? (
                <LinkContainer to={props.item.relativeURL}>{props.item.name}</LinkContainer>
            ) : (
                <a href={props.item.absoluteURL}>{props.item.name}</a>
            )}
        </li>
    );
}

const MIN_ITEMS_FOR_MEGAMENU = 5;

type Props = {
    menuItemList: MenuItem;
};

type State = {
    isOpen: boolean;
};

class MenuItemList extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { isOpen: false };
    }

    componentWillUnmount() {
        window.document.body.classList.remove("disable-page-scrolling");
    }

    showNormalDropdown = (item: MenuItem) => {
        return item.children && item.children.length < MIN_ITEMS_FOR_MEGAMENU && !item.children.some((i) => i.children);
    };
    renderMenu(item: MenuItem) {
        if (this.showNormalDropdown(item)) {
            return (
                <Dropdown.Menu>
                    {item.children.map((c, index) => {
                        return <ListItem item={c} key={index} />;
                    })}
                </Dropdown.Menu>
            );
        }

        return (
            <Dropdown.Menu className="dropdown-menu-fullwidth mfcss_menu-mega dropdown-menu">
                <Wrapper item={item} />
            </Dropdown.Menu>
        );
    }

    dropdownToggle = (item: MenuItem) => {
        if (!this.showNormalDropdown(item)) {
            if (this.state.isOpen) {
                window.document.body.classList.remove("disable-page-scrolling");
            } else {
                window.document.body.classList.add("disable-page-scrolling");
            }
        }
        this.setState({ isOpen: !this.state.isOpen });
    };

    render() {
        const item = this.props.menuItemList;
        let classNameTest;
        if (item.id === "sitecore") {
            classNameTest = "test-ex-sitecore-navbar-global-header";
        } else if (item.id === "categories") {
            classNameTest = "test-ex-assortment-navbar-global-header";
        } else if (item.id === "promotions") {
            classNameTest = "test-ex-promotions-navbar-global-header";
        } else {
            classNameTest = "";
        }
        return (
            <Dropdown id={item.id} className={classNameTest} onToggle={() => this.dropdownToggle(item)}>
                <Dropdown.Toggle>{item.name}</Dropdown.Toggle>
                {this.renderMenu(item)}
            </Dropdown>
        );
    }
}

export default MenuItemList;
